import cn from 'classnames';
import { useContext } from 'react';

import Heading from 'components/common/Heading';
import Slideout, { WIDTH_500 } from 'components/common/Slideout';
import Text from 'components/common/Text';
import IdMeForm from 'components/signUpFunnel/idMe/IdMeForm';
import PromoApplied from 'components/signUpFunnel/promo/PromoApplied';
import PromoCodeForm from 'components/signUpFunnel/promo/PromoCodeForm';
import { BrandContext } from 'context/BrandContext';
import useFetchExperimentAssignment from 'hooks/useFetchExperimentAssignment';
import { TEMPO_IDME_OFFER } from 'lib/constants/experimentConstants';
import { hideIdMe } from 'lib/constants/idme';

const CheckoutSlideOut = ({
  showSlideout,
  setShowSlideout,
  handleApplyButtonClickWithAnalytics,
  hasPromo,
  isIdMeVoucher,
  errorMessage,
  transitionRef,
  setHasPromo,
  setErrorMessage,
  user,
  voucher,
  hasIdMe,
  showIdMeError,
  isFamilyMealPlan,
}) => {
  const { brand } = useContext(BrandContext);
  const { isVariant: isTempoIdMeOfferVariant } = useFetchExperimentAssignment(TEMPO_IDME_OFFER);

  const resetFields = () => {
    if (!hasPromo && !isIdMeVoucher && errorMessage) {
      setErrorMessage(null);
    }
  };

  return (
    <Slideout
      id="order-summary-slideout"
      labelId="order-summary-slideout-label"
      show={showSlideout}
      closeCallback={() => {
        setShowSlideout(false);
        resetFields();
      }}
      desktopWidth={WIDTH_500}
    >
      <div className="mx-6 flex flex-col bp1:mx-8">
        <Heading className="order-first mb-8 mt-4 text-left bp1:text-center bp3:text-left">
          Promo Codes & Gift Cards
        </Heading>
        <div
          className={cn({
            'order-3 mx-0 border-t-2 border-solid border-charcoal-60 bp1:mx-32 bp3:mx-0': hasPromo,
          })}
        >
          {hasPromo && (
            <p className="h5 my-4 text-left bp1:text-center bp3:text-left">
              Change Promo or Gift Card
            </p>
          )}
          <PromoCodeForm
            handleAddVoucherClick={handleApplyButtonClickWithAnalytics}
            errorMessage={errorMessage}
            buttonVariation="Primary"
            formFieldClassName="justify-start bp1:justify-center bp3:justify-start"
            buttonText="Apply"
          />
          {hasPromo && (
            <Text className="textSm py-2 text-left text-charcoal-90 bp1:text-center bp3:text-left">
              Only one promo code can be applied at a time.
            </Text>
          )}
        </div>
        {hasPromo && (
          <PromoApplied
            setHasPromo={setHasPromo}
            setErrorMessage={setErrorMessage}
            isUsaa={user?.isUsaa}
            isAmexUser={user?.isAmex}
            isCourtesyVoucher={voucher?.isCourtesyVoucher}
            hideChangePromoAction
            containerStyles="pt-4 text-primary order-2"
            isFamilyMealPlan={isFamilyMealPlan}
            promoTextStyles="text-left px-0"
          />
        )}
        {!hideIdMe(voucher, user) && (
          <div className="text--hr-header text--hr-header--left text--hr-header--right order-last pt-4">
            <Text
              htmlElement="span"
              brandStylesOverrides="h7"
              className={cn('text--hr-header__heading mb-4 font-medium uppercase', {
                'mt-8': errorMessage?.message,
              })}
            >
              OR
            </Text>{' '}
            <IdMeForm
              showIdMeError={showIdMeError}
              transitionRef={transitionRef}
              brand={brand}
              isFamilyMealPlan={isFamilyMealPlan}
              isBilling={true}
              voucher={voucher}
              hasIdMe={hasIdMe}
              isTempoIdMeOfferVariant={isTempoIdMeOfferVariant}
            />
          </div>
        )}
      </div>
    </Slideout>
  );
};

CheckoutSlideOut.propTypes = {
  showSlideout: PropTypes.bool,
  setShowSlideout: PropTypes.func,
  handleApplyButtonClickWithAnalytics: PropTypes.func,
  hasPromo: PropTypes.bool,
  isIdMeVoucher: PropTypes.bool,
  errorMessage: PropTypes.string,
  transitionRef: PropTypes.object,
  setHasPromo: PropTypes.func,
  setErrorMessage: PropTypes.func,
  user: PropTypes.object,
  voucher: PropTypes.object,
  hasIdMe: PropTypes.bool,
  showIdMeError: PropTypes.bool,
  showPin: PropTypes.bool,
  setShowPin: PropTypes.func,
  isFamilyMealPlan: PropTypes.bool,
};

export default CheckoutSlideOut;
